<template lang="pug">
    div
        template
            Overlay(
                v-show="activeOverlay === 'buildsMenu'"
                uniqueKey="buildsMenu"
                :enableDarkMode="true"
                @close="close"
            )
                template(#header)
                    div(class="flex items-center")
                        div(class="title") Filter Builds

                div(class="overflow-y-scroll lg:max-h-[500px]")
                    SearchRefinementList(attribute="make" title="Make" :isLight="$device.isSmall")

                    SearchRefinementList(attribute="model" title="Model" :isLight="$device.isSmall")

                    SearchRefinementList(attribute="usedFor" title="Interests" :isLight="$device.isSmall")
                        template(#display="{ display }")
                            span(class="capitalize") {{ screamingSnakeToTitle(display) }}

                    SearchRefinementList(attribute="products.brand" title="Brands" :isLight="$device.isSmall")

                template(#footer)
                    div(class="flex")
                        BaseButton(
                            color="BLACK"
                            class="text-primary flex-1"
                            hasCustomTextColor
                            @click.native="close"
                        ) Apply Filters

</template>

<script>
import SearchComponent from '@/components/search/component'
import SearchRefinementList from '@/components/search/refinementList'
import SearchStats from '@/components/search/stats'
import BaseButton from '@/components/baseButton'
const Overlay = () => import(/* webpackChunkName: "overlay" */ '@/components/overlay')

export default {
    name: 'Refinements',
    components: {
        SearchRefinementList,
        SearchStats,
        BaseButton,
        Overlay,
    },
    extends: SearchComponent,
    computed: {
        activeOverlay() {
            return this.$overlay.state.activeOverlay
        },
    },
    async mounted() {
        await this.$overlay.registerUrlKey('buildsMenu', { isPersistent: true })
    },
    methods: {
        screamingSnakeToTitle: (value) => value.toLowerCase().replace('_', ' '),
        trackRefinement(data) {
            const { title, value } = data

            this.$uiEvents.$emit('facetClicked', {
                facet: title.toLowerCase(),
                value: value.toLowerCase(),
                route: this.$route,
            })
        },
        close() {
            this.$overlay.hide()
        },
        clearRefinements() {
            this.$searchContext.clearRefinements()

            // Right now we remove mod from the url manually here. if we wanted to make sure we don't
            // close the menu when we clear we would need to make sure we leave it in the query string.
            const route = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                },
                query: {
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$push.to(route)
        },
    },
}
</script>
